<img [src]="transform(url)" class="imgUpload" *ngIf="url != null && !arquivoUpload">

<div class="div_image-cropper" *ngIf="arquivoUpload">
  <image-cropper [imageURL]="url" [aspectRatio]="4/4" format="jpeg" (imageCropped)="imageCropped($event)"
    [roundCropper]="true" [containWithinAspectRatio]="true" alignImage="center" backgroundColor="#000000">
  </image-cropper>
</div>

<p class="cs_label titulo_label">ALTERAR FOTO DE PERFIL</p>

<div class="divBotoes">
  <label for="file-upload" class="cs_botao">Carregar Foto</label>
  <input type="file" (change)="selectFiles($event)" id="file-upload" accept="image/png, image/jpeg" hidden />
  <button class="cs_botao confirmar_botao" (click)="confirmar()" [hidden]="!confirmarEnvio">Confirmar</button>
</div>

<div class="mb-2 divBotoes file-info" *ngIf="progressInfo != null && progressInfo.fileName != ''">
  <span>{{ progressInfo.fileName }}</span>
  <div class="progress">
    <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
      attr.aria-valuenow="{{ progressInfo.value }}" aria-valuemin="0" aria-valuemax="100"
      [ngStyle]="{ width: progressInfo.value + '%' }">
      {{ progressInfo.value }}%
    </div>
  </div>
</div>

<div class="alert alert-light cs_label" role="alert" [hidden]="message == ''">{{ message }}</div>
